import type { CartItem } from '../context/CartContext';

const STORAGE_KEY = 'nls_pending_auth_action';

export type PendingAuthAction =
  | {
      type: 'addToCart';
      productId: string;
      quantity: number;
      localItem?: CartItem;
    }
  | {
      type: 'buyNow';
      buyNowProduct: Record<string, unknown>;
    }
  | {
      type: 'wishlist';
      productId: string;
      add: boolean;
    }
  | {
      type: 'navigate';
      path: string;
    };

export function savePendingAuthAction(action: PendingAuthAction): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(action));
}

export function peekPendingAuthAction(): PendingAuthAction | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as PendingAuthAction;
  } catch {
    return null;
  }
}

export function consumePendingAuthAction(): PendingAuthAction | null {
  const action = peekPendingAuthAction();
  sessionStorage.removeItem(STORAGE_KEY);
  return action;
}

export function clearPendingAuthAction(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
